export default function AboutStory() {
  return (
    <section className="bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 lg:py-20">
        <h2 className="text-2xl lg:text-[36px] font-medium text-[#333333] mb-6">Our story</h2>
        <p className="text-lg text-[#677078] leading-relaxed max-w-7xl">
          Alphaden Exploration & Production Limited is an indigenous Nigerian company that helps upstream operators in Nigeria and West Africa drill faster, safer, and at a lower total cost. We combine certified equipment, practical financing, and in-country support so your team can move from plan to production with confidence.
        </p>
      </div>

      <div className="grid lg:grid-cols-2">
        <div className="relative h-[600px] lg:h-auto">
          <img
            src="https://res.cloudinary.com/dpkn1ppzj/image/upload/v1770029081/Frame_2147226678_1_ygdsew.png"
            alt="Oil and gas worker at facility"
            className="w-full h-full object-cover"
          />
        </div>

        <div className="flex flex-col">
          <div className="bg-[#00458F] text-white p-12 lg:p-16 flex-1 flex items-center">
            <div className="max-w-[451px] mx-auto">
              <h2 className="text-4xl lg:text-[40px] font-medium mb-4">Our mission</h2>
              <p className="leading-relaxed">
                To be the first call for planning, mobilization, and production by making world-class equipment and financing accessible to every operator.
              </p>
            </div>
          </div>

          <div className="bg-[#333333] text-white p-12 lg:p-16 flex-1 flex items-center">
            <div className="max-w-[451px] mx-auto">
              <h2 className="text-4xl lg:text-[40px] font-medium mb-4">Our vision</h2>
              <p className="leading-relaxed">
                Enable operators in Nigeria and West Africa to cut drilling cost and risk with certified equipment, pay-per-use models, and in-country support.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
